<app-content>
  <app-breadcrumbs>
    <li>
      Moje opłaty
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Moje opłaty
    </h2>
    @if (authed) {
      <ng-container *ngIf='!loading()'>
        <div class='row'>
          <div class='col-md-6'>
            <div class='form-group'>
              <label for='name'>Szukaj</label>
              <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                     placeholder='Wpisz nazwę lub adres' />
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-8'>
            <ul class='item-list'>
              <li style='max-width: fit-content'
                  *ngFor='let item of services() | filterData: filterValue : false : "tag"'>
                <div>
                  <a
                    [routerLink]="[item?.identSigid, item?.code]">
                    {{ item?.name || 'Nieznana usługa' }}
                  </a>&nbsp;
                </div>
                <div>
                  <small>
                    Adres: <strong>{{ item?.street }}, {{ item?.town }}</strong>
                  </small>
                </div>
              </li>
            </ul>
            <app-alert
              *ngIf='!(services() | filterData: filterValue : false : "tag").length'
              content='Brak wyników'
              [closable]='false'>
            </app-alert>
          </div>
        </div>
      </ng-container>
      <app-spinner *ngIf='loading()'>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <app-alert [closable]="false">
        Dostęp do Twoich zobowiązań i opłat jest możliwy <strong>wyłącznie po zalogowaniu.</strong> Po zalogowaniu uzyskasz możliwość przeglądania i regulowania swoich opłat.
      </app-alert>
    }
  </section>
</app-content>
